var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[(_vm.showBox)?_c('div',{style:(_vm.flagsStyle),attrs:{"id":"timeline-flags"},on:{"mouseover":_vm.overShow,"mouseout":_vm.outHide,"mousedown":function($event){return _vm.stopDocument($event)}}},[_c('div',{staticClass:"content-body"},_vm._l((_vm.sprites),function(sprite){return _c('div',{class:{'sprite-flag': true, active: _vm.selectSpritesId.indexOf(sprite.id) > -1},on:{"click":function($event){$event.stopPropagation();return _vm.setSelect($event, sprite)}}},[_c('div',{ref:"cloneWrapper",refInFor:true,domProps:{"innerHTML":_vm._s(sprite.getThumbnail().children()
          .css({
            // width: 'auto',
            // height: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
            transform: 'none'
          }).prop('outerHTML'))}})])}),0),_vm._v(" "),_c('div',{staticClass:"t-triangle"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ed9edec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/timelineFlag.vue
// module id = null
// module chunks = 